import React from "react";
import { motion } from "framer-motion";
import { scaleCustomerCommunication } from "../Data";

// Stagger container variants for grid rows
const gridVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

// Standard clean fade-up animation
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const AutomationCard = ({ item }) => {
  return (
    <motion.div
      className="automation-card"
      variants={fadeUpVariants}
      whileHover={{ y: -6 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      <p className="card-number">{item.number}</p>

      <div className="automation-icon-wrapper">
        <img src={item.icon} alt={`${item.title} | Onbbits`} />
      </div>

      <h3 className="card-heading">{item.title}</h3>

      <p className="section-text">{item.desc}</p>
    </motion.div>
  );
};

const ScaleCustomerCommunication = () => {
  return (
    <section className="automation-section customer-section">
      <div className="container">

        {/* Heading Section */}
        <div className="feature-heading">

          <motion.div
            className="feature-left"
            variants={fadeUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2 className="section-heading">
              Simplify and scale customer
              <br />
              <span>
                {" "}communication —everywhere
              </span>
            </h2>
          </motion.div>

          <motion.div
            className="feature-right"
            variants={fadeUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <p className="section-text">
              Unify conversations, automate engagement,
              and deliver seamless customer experiences
              at every stage of the journey.
            </p>
          </motion.div>

        </div>

        {/* Automation Grid */}
        <div className="automation-grid">

          {/* ---------- TOP ROW ---------- */}
          <motion.div
            className="automation-grid-top"
            variants={gridVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
          >
            {scaleCustomerCommunication
              .slice(0, 3)
              .map((item, i) => (
                <AutomationCard
                  key={i}
                  item={item}
                />
            ))}
          </motion.div>

          {/* ---------- BOTTOM ROW ---------- */}
          <motion.div
            className="automation-grid-bottom"
            variants={gridVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
          >
            {scaleCustomerCommunication
              .slice(3)
              .map((item, i) => (
                <AutomationCard
                  key={i + 3}
                  item={item}
                />
            ))}
          </motion.div>

        </div>

      </div>
    </section>
  );
};

export default ScaleCustomerCommunication;